import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule } from '@angular/router';
import { AnnouncementModule } from '@sb/library/announcement';
import { BaseModule } from '@sb/library/base';
import { ButtonModule } from '@sb/library/button';
import { IconModule } from '@sb/library/icon';
import { SectionHeaderComponent } from './section-header/section-header.component';
import { ApplicationLayoutContainerComponent } from './application-layout-container/application-layout-container.component';
import { DetailViewLayoutComponent } from './detail-view/detail-view-layout.component';
import { DialogLayoutComponent } from './dialog/dialog-layout.component';
import { DrawerLayoutComponent } from './drawer/drawer-layout.component';
import { HeaderComponent } from './header/header.component';
import { LayoutDrawerModePipe } from './layout-drawer-mode.pipe';
import { LayoutRowComponent } from './row/layout-row.component';
import { SideBarItemComponent } from './sidebar/sidebar-item/sidebar-item.component';
import { SideBarLogoComponent } from './sidebar/sidebar-logo/sidebar-logo.component';
import { SidebarOverflowItemComponent } from './sidebar/sidebar-overflow-item/sidebar-overflow-item.component';
import { SnackbarLayoutComponent } from './snackbar/snackbar-layout.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BadgeModule } from '@sb/library/badge';
import { DividerComponent } from './divider/divider.component';
import { LoadingSpinnerComponent } from './loading/spinner/spinner.component';

@NgModule({
    declarations: [
        HeaderComponent,
        ApplicationLayoutContainerComponent,
        SideBarItemComponent,
        SideBarLogoComponent,
        SidebarOverflowItemComponent,
        LayoutRowComponent,
        DialogLayoutComponent,
        DetailViewLayoutComponent,
        SnackbarLayoutComponent,
        LayoutDrawerModePipe,
        DrawerLayoutComponent,
        SectionHeaderComponent,
        DividerComponent,
        LoadingSpinnerComponent
    ],
    imports: [
        BaseModule,
        CommonModule,
        AnnouncementModule,
        MatListModule,
        MatDividerModule,
        IconModule,
        RouterModule,
        ButtonModule,
        PortalModule,
        BadgeModule,
        MatTooltipModule,
        MatDialogModule
    ],
    exports: [
        ApplicationLayoutContainerComponent,
        SideBarItemComponent,
        SideBarLogoComponent,
        SidebarOverflowItemComponent,
        LayoutRowComponent,
        DialogLayoutComponent,
        DetailViewLayoutComponent,
        SnackbarLayoutComponent,
        DrawerLayoutComponent,
        SectionHeaderComponent,
        DividerComponent,
        LoadingSpinnerComponent
    ]
})
export class LayoutModule { }
